module.exports = __webpack_public_path__ + "images/psp/SelfStorage/what-is-self-storage-hero.png";